import {
  VStack,
  useDisclosure,
  useMediaQuery,
  Center,
  Icon,
  Button,
  useToast,
  Box,
} from '@chakra-ui/react';
import { FC } from 'react';
import { useSubmitSurvey as useJoinWaitlist } from '@frx/frx-react-context';
import { Modal, Notification, QuestionsForm } from '../../../../components';
import { PeopleGroupOutline } from '../../../../assets';
import { useLuminateConfig } from '../../../../hooks';
import { getDataTracking } from '../../../../utils';

export const CreateTeamModal: FC<{ questions: any }> = ({ questions = [] }) => {
  const [isMobile] = useMediaQuery('(max-width: 768px)');
  const { isOpen, onClose, onOpen } = useDisclosure();
  const { heroesFormTeamSurveyId } = useLuminateConfig();
  const { mutate: submitSurvey, isError, error } = useJoinWaitlist();
  const toast = useToast();

  const handleOnSubmit = (options: any) => {
    submitSurvey(
      {
        ...options,
        survey_id: heroesFormTeamSurveyId,
      },
      {
        onSuccess: () => {
          onClose();
          toast({
            title: 'Survey Submitted',
            status: 'success',
            duration: 2000,
          });
        },
      }
    );
  };

  return (
    <>
      <Button
        w="full"
        height="143px"
        colorScheme="blue"
        variant="secondary"
        onClick={onOpen}
        {...getDataTracking('createTeamButton')}
      >
        <VStack>
          <Center>
            <Icon as={PeopleGroupOutline} boxSize="64px" />
          </Center>
          <Center>Create a Team</Center>
        </VStack>
      </Button>
      <Modal isOpen={isOpen} onClose={onClose} size={isMobile ? 'lg' : '2xl'}>
        {isError && (
          <Box pb={4}>
            <Notification status="error" message={error?.message || ''} />
          </Box>
        )}
        <QuestionsForm
          questions={questions}
          onSubmit={handleOnSubmit}
          hasSubmit
          buttonText="Continue"
        />
      </Modal>
    </>
  );
};
